import React from "react";
import { Link } from "react-router-dom";
import { Icon } from "@culturehq/components";

import { getDepartmentPath, getInterestPath, getLocationPath, getPostPath, getProfilePath, getSkillPath, getStoryPath, getStoryTrendPath } from "app/links";
import { getCompanyPath } from "app/links/CompanyLink";

import getText from "components/editor/getText";

const ICONS = {
  companies: "building",
  departments: "ios-people",
  events: "calendar",
  interests: "heart",
  locations: "ios-location",
  photos: "images",
  posts: "speakerphone",
  skills: "hammer",
  users: "ios-person",
  stories: "tale",
  story_questions: "book-filled"
};

const searchResultLink = (type, id, questionId) => {
  switch (type) {
    case "announcements":
      return "/";
    case "companies":
      return getCompanyPath({ id });
    case "departments":
      return getDepartmentPath({ id });
    case "events":
      return `/events/${id}`;
    case "interests":
      return getInterestPath({ id });
    case "locations":
      return getLocationPath({ id });
    case "photos":
      return "/photos";
    case "posts":
      return getPostPath({ id });
    case "skills":
      return getSkillPath({ id });
    case "users":
      return getProfilePath({ id });
    case "stories":
      return getStoryPath({ questionId, id });
    case "story_questions":
      return getStoryTrendPath({ question: { id } });
    default:
      return "/";
  }
};

const SearchResultDetails = React.memo(({ type, details }) => {
  if (type === "events" || type === "posts" || type === "stories") {
    return <small>{getText(details)}</small>;
  }

  return <small>{details}</small>;
});

const SearchResult = ({ result, onClearSearchResults }) => {
  const { type, id, name, details, questionId } = result;

  return (
    <Link className="chq-nav--result" to={searchResultLink(type, id, questionId)} onClick={onClearSearchResults}>
      <em><Icon icon={ICONS[type]} /></em>
      <span>
        {name && <strong>{name}</strong>}
        {name && details && <br />}
        {details && <SearchResultDetails type={type} details={details} />}
      </span>
    </Link>
  );
};

export default SearchResult;
